"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.default = (function (props) { return (react_1.default.createElement("div", { className: "page-title flex flex-column" },
    react_1.default.createElement("div", { className: "content" },
        react_1.default.createElement("h1", null, props.children)))); });
